import { apiClient } from './apiClient';

// 실제 API 응답에 맞춘 문의 인터페이스
export interface InquiryItem {
  id: number;
  title: string;
  content: string;
  inquirer_name: string;
  inquired_at: string;
  attachments: any[];
  reply: any | null;
}

// 관리자 페이지에서 사용할 문의 인터페이스 (변환된 형태)
export interface Inquiry {
  id: number;
  title: string;
  content: string;
  author: string;
  createdAt: string;
  attachments: any[];
  reply: any | null;
  hasReply: boolean;
}

export interface InquiryListParams {
  page?: number;
  size?: number;
  category?: string;
  status?: string;
  author?: string;
  search?: string;
}

// 실제 API 응답 구조
export interface ApiResponse<T> {
  code: number;
  status: string;
  message: string;
  data: T;
}

export interface InquiryListData {
  content: InquiryItem[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: any;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  totalElements: number;
  totalPages: number;
  last: boolean;
  size: number;
  number: number;
  sort: any;
  numberOfElements: number;
  first: boolean;
  empty: boolean;
}

export interface InquiryListResponse {
  content: Inquiry[];
  totalPages: number;
  totalElements: number;
  currentPage: number;
  size: number;
}

// API 응답을 관리자 인터페이스로 변환하는 헬퍼 함수
const convertToAdminInquiry = (item: InquiryItem): Inquiry => ({
  id: item.id,
  title: item.title,
  content: item.content,
  author: item.inquirer_name,
  createdAt: item.inquired_at,
  attachments: item.attachments,
  reply: item.reply,
  hasReply: item.reply !== null
});

// 문의 API 서비스
export const inquiryApi = {
  // 문의 목록 조회
  getInquiries: async (params: InquiryListParams = {}): Promise<InquiryListResponse> => {
    try {
      const response = await apiClient.get<ApiResponse<InquiryListData>>('/api/admin/inquiries/list', { params });
      
      if (response.data.code === 200) {
        const data = response.data.data;
        return {
          content: data.content.map(convertToAdminInquiry),
          totalPages: data.totalPages,
          totalElements: data.totalElements,
          currentPage: data.number,
          size: data.size
        };
      } else {
        throw new Error(response.data.message || '문의 목록 조회에 실패했습니다.');
      }
    } catch (error: any) {
      /// console.error('Error fetching inquiries:', error);
      throw new Error(error.message || '문의 목록 조회 중 오류가 발생했습니다.');
    }
  },

  // 문의 상세 조회
  getInquiryById: async (id: number): Promise<Inquiry> => {
    try {
      const response = await apiClient.get<ApiResponse<InquiryItem>>(`/api/admin/inquiries/${id}`);
      
      if (response.data.code === 200) {
        return convertToAdminInquiry(response.data.data);
      } else {
        throw new Error(response.data.message || '문의 상세 조회에 실패했습니다.');
      }
    } catch (error: any) {
      /// console.error('Error fetching inquiry:', error);
      throw new Error(error.message || '문의 상세 조회 중 오류가 발생했습니다.');
    }
  },

  // 문의 삭제
  deleteInquiry: async (id: number): Promise<void> => {
    try {
      const response = await apiClient.delete<ApiResponse<any>>(`/api/admin/inquiries/${id}`);
      
      if (response.data.code !== 200) {
        throw new Error(response.data.message || '문의 삭제에 실패했습니다.');
      }
    } catch (error: any) {
      /// console.error('Error deleting inquiry:', error);
      throw new Error(error.message || '문의 삭제 중 오류가 발생했습니다.');
    }
  }
};